
const service = {
    showCardsForQuestions(questionSlugs) {
        const $cards = $('aside .card-list .card--snippet')
        $cards.hide()
        for (const card of $cards) {
            if (questionSlugs.includes(card.dataset['questionSlug'])) {
                $(card).fadeIn("slow")
            }
        }
    },
}

export default service
